export const caramelOrange = '#DB942A'
export const coralRed = 'rgba(251, 99, 64, 1)'
export const coralRedLight = 'rgba(251, 99, 64, 0.6)'
export const peach = 'rgba(255, 232, 210, 1)'
export const deepEmeraldGreen = 'rgba(21, 140, 89, 1)'
export const deepEmeraldGreenLight = 'rgba(21, 140, 89, 0.6)'
export const crimsonRed = 'rgba(241, 29, 71, 1)'
export const crimsonRedLight = 'rgba(241, 29, 71, 0.6)'
export const brand = '#5138ee'
export const white = '#fff'
export const midnightShadow = 'rgba(4, 4, 16, 0.6)'
export const lavenderMist = 'rgba(81, 56, 238, 0.08)'
export const offWhite = 'rgba(248, 248, 249, 1)'
